import {
  Box,
  Button,
  Card,
  CardActions,
  CircularProgress,
} from "@mui/material";
import * as React from "react";
import { useState } from "react";
import {
  email,
  Form,
  required,
  TextInput,
  useNotify,
  useTranslate,
} from "react-admin";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import sendRequest from "../dataProvider/sendRequest";

interface FormValues {
  email: string;
}

const ForgetPasswordPage = () => {
  const [loading, setLoading] = useState(false);
  const translate = useTranslate();
  const notify = useNotify();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const [checkPwdOneUppercase, setCheckPwdOneUppercase] = React.useState(false);
  const [checkPwdOneLowercase, setCheckPwdOneLowercase] = React.useState(false);
  const [checkPwdOneNumber, setCheckPwdOneNumber] = React.useState(false);
  const [checkPwd8Char, setCheckPwd8Char] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState("");
  const handleSubmit = async (auth: FormValues) => {
    setLoading(true);
    const reqUrl = "forget-password";
    const formJson = {
      email: auth.email,
    };
    const response = await sendRequest(reqUrl, {
      id: 0,
      data: formJson,
    });
    if (response && (response.status == "200" || response.code == "200")) {
      setSuccessMessage("We have e-mailed your password reset link!");
      setLoading(false);
    } else {
      if (response && response.message) {
        notify(response.message, { type: "error" });
      } else {
        notify("Email send failed", { type: "error" });
      }

      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "flex-start",
          backgroundColor: "#f2f7fa",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <Card sx={{ minWidth: 300, marginTop: "6em", padding: "2em" }}>
          <Box
            sx={{
              margin: "1em",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img src="/images/happymango_logo.png" alt="logo" border="0" />
          </Box>
          <Box
            sx={{
              marginTop: "1em",
              display: "flex",
              justifyContent: "center",
              color: (theme) => theme.palette.grey[500],
            }}
          >
            RESET PASSWORD
          </Box>
          <Box
            sx={{
              marginTop: "1em",
              display: "flex",
              justifyContent: "center",
              color: (theme) => theme.palette.grey[500],
            }}
          >
            To reset your password, enter the email address you used to sign up
            your Happy Mango account.
          </Box>
          {successMessage && (
            <>
              <Box
                sx={{
                  marginTop: "1em",
                  display: "flex",
                  justifyContent: "center",
                  color: (theme) => theme.palette.success.main,
                }}
              >
                {successMessage}
              </Box>
              <Box
                sx={{
                  textAlign: "center",
                  width: "100%",
                  mt: 1,
                }}
              >
                <Link
                  to="/login"
                  style={{
                    textDecoration: "none",
                    color: "#00CCB1",
                  }}
                >
                  Back to Login
                </Link>
              </Box>
            </>
          )}
          {!successMessage && (
            <>
              <Box sx={{ mt: 2, padding: "0 1em 1em 1em" }}>
                <TextInput
                  source="email"
                  label="Email"
                  type="email"
                  variant="outlined"
                  fullWidth
                  validate={(required(), email())}
                />
              </Box>
              <CardActions
                sx={{
                  padding: "0 1em 1em 1em",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disabled={loading}
                  sx={{
                    backgroundColor: "#00ccb1",
                    "&:hover": {
                      backgroundColor: "#00b39b",
                    },
                  }}
                >
                  {loading && <CircularProgress size={25} thickness={2} />}
                  Send Password Reset Link
                </Button>
              </CardActions>
            </>
          )}
        </Card>
      </Box>
    </Form>
  );
};

export default ForgetPasswordPage;
